import $ from 'jquery';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

const namespace = 'filter-canvas';

export default class FilterCanvas {
  query = window.matchMedia('(min-width: 50em)');

  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          target: '.js-filters__target',
          trigger: '.js-filters__trigger',
          counter: '.js-filters__counter',
          content: '.js-filters__content',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.$el = $(el);
    this.$target = $(this.options.selectors.target, this.$el);
    this.$content = $(this.options.selectors.content, this.$el);
    this.content = this.$content.get(0);
    this.$trigger = $(this.options.selectors.trigger, this.$el);
    this.$counter = $(this.options.selectors.counter, this.$el);

    this.bind();
    this.check(this.query);
  }

  bind() {
    this.query.addListener(this.check.bind(this));

    $(document).on('collection:updated', this.close.bind(this));
    $(document).on('filters:count', this.handleCount.bind(this));

    this.$el.on(
      `click.${namespace}`,
      this.options.selectors.trigger,
      this.toggleLock.bind(this),
    );

    $(document).on(
      `click.closeall.${namespace}`,
      this.handleDocumentClick.bind(this),
    );
  }

  /**
   * @param {Event} _
   * @param {Object} data
   */
  handleCount(_, data) {
    const {count} = data;

    this.$counter.html(parseInt(count, 10));
  }

  /**
   * @param {Event} event
   */
  handleDocumentClick(event) {
    const $target = $(event.target);
    const isChild = (this.$el.has($target).length >= 1);

    if (!isChild && this.isActive()) {
      this.close();
    }
  }

  /**
   * @param {Event|MediaQueryList} event
   */
  check(event) {
    if (event.matches) {
      return enableBodyScroll(this.content);
    }

    if (!event.matches && !this.isActive()) {
      return null;
    }

    return disableBodyScroll(this.content);
  }

  close() {
    enableBodyScroll(this.content);
    this.$target.toggleClass(this.options.classes.active, false);
    this.$trigger.attr('aria-expanded', false);
  }

  toggleLock() {
    this.$target.toggleClass(this.options.classes.active);

    if (this.isActive()) {
      if (!this.query.matches) {
        disableBodyScroll(this.content);
      }

      this.$trigger.attr('aria-expanded', true);
      return;
    }

    if (!this.query.matches) {
      enableBodyScroll(this.content);
    }

    this.$trigger.attr('aria-expanded', false);
  }

  /**
   * @returns {Boolean}
   */
  isActive() {
    return this.$target.hasClass(this.options.classes.active);
  }
}
